<div class="loading-spinner">
  <mat-spinner diameter="{{ diameter }}"></mat-spinner>
</div>
